window.app_models = {
    
};

/*Load Models*/
require('./option');
require('./state');
require('./address');
require('./loss_address');
require('./company');
require('./company_contact');
require('./contact');
require('./event');
require('./property_contact');
require('./amenities');
require('./vacate_notice');
require('./unit_detail');
require('./budget_item');
require('./budget_markup');
require('./invoice_request');
require('./payment_request');
require('./budget');
require('./lease_detail');
require('./property');
require('./property_list');
require('./properties');
require('./placement_contact');
require('./contact_history');
require('./child');
require('./children');
require('./policyholder');
require('./hotel');
require('./room');
require('./note');
require('./hotel_placement');
require('./placement');


// WEBPACK FOOTER //
// ./resources/assets/js/models/index.js